export type MediaType = "movie" | "tvseries";

export interface Movie {
  id: string;
  title: string;
  type: MediaType;
  genres: string[];
  year: number;
  region: string;
  rating: number;
  hot: number;
  duration: string;
  director: string;
  cast: string[];
  poster: string;
  banner?: string;
  featured?: boolean;
  updatedAt: string;
  summary: string;
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: "chang-an-huan-ye",
    title: "长安幻夜",
    type: "movie",
    genres: ["剧情", "奇幻", "悬疑"],
    year: 2025,
    region: "中国大陆",
    rating: 8.6,
    hot: 98450,
    duration: "128分钟",
    director: "陈砚舟",
    cast: ["沈知夏", "陆行舟", "苏含烟"],
    poster: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20glowing%20lanterns%20and%20misty%20palace%20roofs%2C%20moody%20cinematic%20movie%20poster%2C%20warm%20vermillion%20and%20deep%20charcoal%20tones%2C%20artistic%20painterly%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20at%20dusk%20with%20glowing%20red%20lanterns%20and%20swirling%20mist%2C%20cinematic%20wide%20scene%2C%20warm%20vermillion%20and%20charcoal%20tones%2C%20dark%20atmospheric%20moody%20artistic%20style%2C%20no%20text&width=1600&height=900&seq=mv-banner-01&orientation=landscape",
    featured: true,
    updatedAt: "2025-09-28",
    summary: "一桩离奇命案牵动长安城，少年画师被卷入跨越百年的幻夜迷局。",
    synopsis: "唐时长安，入夜后坊市传闻有“幻夜”之说，凡入夜者所见皆真亦皆幻。少年画师沈砚因一幅无名壁画被卷入命案，与大理寺捕快联手追查，逐渐揭开一段被刻意抹去的百年旧事。影片以水墨般的镜头语言与层层递进的悬念，呈现一个繁华与诡秘并存的盛唐长安。",
  },
  {
    id: "feng-huo-chang-he",
    title: "烽火长河",
    type: "movie",
    genres: ["历史", "战争", "剧情"],
    year: 2024,
    region: "中国大陆",
    rating: 9.0,
    hot: 120300,
    duration: "156分钟",
    director: "韩振国",
    cast: ["秦卫东", "苏晚", "林致华"],
    poster: "https://readdy.ai/api/search-image?query=Epic%20historical%20war%20battlefield%20with%20distant%20smoke%20and%20a%20lone%20silhouette%20soldier%2C%20dramatic%20cinematic%20movie%20poster%2C%20muted%20earth%20and%20deep%20red%20tones%2C%20painterly%20textured%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Vast%20historical%20battlefield%20at%20golden%20sunset%20with%20distant%20mountain%20ranges%20and%20drifting%20smoke%2C%20epic%20cinematic%20wide%20composition%2C%20muted%20earth%20tones%20with%20deep%20crimson%20accents%2C%20painterly%20style%2C%20no%20text&width=1600&height=900&seq=mv-banner-02&orientation=landscape",
    featured: true,
    updatedAt: "2025-08-14",
    summary: "一条长河，两代将士，在乱世烽火中守护家国最后的防线。",
    synopsis: "以一条贯穿南北的长河为线索，讲述两代将士在家国危难时刻的抉择与坚守。影片用群像叙事刻画普通士兵的悲欢，既有恢弘的战争场面，也有细腻的人物刻画，被誉为近年来国产历史题材的代表之作。",
  },
  {
    id: "wu-du-yi-yun",
    title: "雾都疑云",
    type: "movie",
    genres: ["悬疑", "犯罪", "剧情"],
    year: 2025,
    region: "中国香港",
    rating: 8.2,
    hot: 87600,
    duration: "112分钟",
    director: "林致华",
    cast: ["周衍", "何静雯", "陆行舟"],
    poster: "https://readdy.ai/api/search-image?query=Rainy%20foggy%20city%20street%20at%20night%20with%20neon%20reflections%20and%20a%20lone%20figure%20under%20an%20umbrella%2C%20mystery%20thriller%20movie%20poster%2C%20cold%20grey%20with%20warm%20amber%20accents%2C%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-03&orientation=portrait",
    updatedAt: "2025-09-20",
    summary: "连环失踪案背后，一位老刑警在迷雾般的线索中寻找被遗忘的真相。",
    synopsis: "一座常年笼罩在雾气中的城市，接连发生离奇失踪案。经验丰富却即将退休的老刑警与年轻搭档联手调查，却发现案件背后牵涉一桩多年前被草草结案的旧案。真相在迷雾中一点点浮现，也考验着每个人对正义的坚持。",
  },
  {
    id: "shan-hai-xing-tu",
    title: "山海星途",
    type: "movie",
    genres: ["科幻", "冒险", "剧情"],
    year: 2025,
    region: "中国大陆",
    rating: 8.8,
    hot: 132900,
    duration: "142分钟",
    director: "顾云帆",
    cast: ["江砚", "白露", "蓝意"],
    poster: "https://readdy.ai/api/search-image?query=Futuristic%20spacecraft%20hovering%20above%20a%20mysterious%20alien%20mountain%20range%2C%20sci-fi%20adventure%20movie%20poster%2C%20teal%20shadow%20with%20warm%20amber%20highlights%2C%20cinematic%20glossy%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Cosmic%20landscape%20with%20immense%20floating%20mountains%20under%20a%20star%20nebula%2C%20lone%20spacecraft%20silhouette%2C%20sci-fi%20cinematic%20wide%20scene%2C%20deep%20indigo%20shadow%20with%20warm%20orange%20glow%2C%20artistic%20style%2C%20no%20text&width=1600&height=900&seq=mv-banner-04&orientation=landscape",
    featured: true,
    updatedAt: "2025-10-05",
    summary: "一场横跨星海的远征，人类在陌生星系寻找文明延续的答案。",
    synopsis: "近未来，地球资源濒临枯竭，一支远征舰队穿越虫洞前往未知星系。船长与年轻工程师在探索中遭遇远超预期的挑战，也重新思考文明、牺牲与归途的意义。影片以恢弘的视效和扎实的情感内核，构建了一个可信的国产科幻世界。",
  },
  {
    id: "chun-feng-guo-jing",
    title: "春风过境",
    type: "movie",
    genres: ["爱情", "剧情"],
    year: 2024,
    region: "中国大陆",
    rating: 7.9,
    hot: 65200,
    duration: "118分钟",
    director: "温以宁",
    cast: ["许清晏", "罗子谦", "夏栀"],
    poster: "https://readdy.ai/api/search-image?query=Warm%20sunlit%20countryside%20town%20with%20blossoming%20trees%20and%20a%20couple%20walking%20a%20quiet%20lane%2C%20romantic%20drama%20movie%20poster%2C%20soft%20warm%20beige%20and%20gentle%20red%20tones%2C%20film%20photography%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-05&orientation=portrait",
    updatedAt: "2025-06-30",
    summary: "小城相遇的两个人，在春风里走过一段温柔又遗憾的时光。",
    synopsis: "江南小城，一个离开又归来的青年与守着旧书店的姑娘相遇。两人在四季流转中彼此靠近，又不得不面对现实的选择。影片以细腻的生活质感与克制的叙事，讲述一段关于成长与告别的温暖故事。",
  },
  {
    id: "jiang-hu-yi-ye-zhou",
    title: "江湖一叶舟",
    type: "movie",
    genres: ["武侠", "动作", "剧情"],
    year: 2023,
    region: "中国大陆",
    rating: 8.4,
    hot: 71800,
    duration: "134分钟",
    director: "沈墨白",
    cast: ["燕无归", "苏含烟", "秦卫东"],
    poster: "https://readdy.ai/api/search-image?query=Lone%20martial%20artist%20standing%20on%20a%20small%20boat%20in%20misty%20river%20at%20dawn%2C%20wuxia%20action%20movie%20poster%2C%20ink%20wash%20grey%20with%20warm%20red%20accent%2C%20painterly%20oriental%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-06&orientation=portrait",
    updatedAt: "2025-05-12",
    summary: "一叶孤舟漂过江湖，恩怨情仇都随流水远去。",
    synopsis: "归隐多年的剑客因一桩旧怨被迫重出江湖，沿途结识形形色色的人，也逐渐看清所谓江湖的真面目。影片摒弃浮夸的特效，以写实的打斗与水墨般的画面，还原一个含蓄而苍凉的武侠世界。",
  },
  {
    id: "yan-huo-ren-jian",
    title: "烟火人间",
    type: "tvseries",
    genres: ["家庭", "剧情"],
    year: 2025,
    region: "中国大陆",
    rating: 8.7,
    hot: 156700,
    duration: "全40集",
    director: "赵砚秋",
    cast: ["何永年", "林素芬", "温以宁"],
    poster: "https://readdy.ai/api/search-image?query=Cozy%20Chinese%20family%20gathered%20around%20a%20warm%20dinner%20table%20in%20a%20traditional%20courtyard%20home%2C%20heartwarming%20family%20drama%20poster%2C%20warm%20amber%20and%20soft%20red%20tones%2C%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=tv-poster-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Warm%20evening%20view%20of%20a%20traditional%20Chinese%20courtyard%20home%20with%20glowing%20windows%20and%20rising%20smoke%2C%20cozy%20cinematic%20wide%20scene%2C%20warm%20amber%20and%20soft%20crimson%20tones%2C%20artistic%20style%2C%20no%20text&width=1600&height=900&seq=tv-banner-07&orientation=landscape",
    featured: true,
    updatedAt: "2025-10-02",
    summary: "一条老街，三代同堂，在锅碗瓢盆里煮出最真实的人间烟火。",
    synopsis: "故事围绕一条老街上经营小饭馆的一家人展开，通过一日三餐串联起三代人的生活百态。剧集以平实温暖的笔触描摹亲情、邻里与时代的变迁，让每个观众都能在熟悉的烟火气里找到自己的影子。",
  },
  {
    id: "po-xiao-xing-zhen",
    title: "破晓刑侦",
    type: "tvseries",
    genres: ["悬疑", "犯罪", "剧情"],
    year: 2025,
    region: "中国大陆",
    rating: 8.5,
    hot: 143200,
    duration: "全36集",
    director: "郑行远",
    cast: ["方锐", "江雪", "周衍"],
    poster: "https://readdy.ai/api/search-image?query=Detective%20team%20silhouettes%20in%20a%20dim%20crime%20scene%20with%20evidence%20board%20and%20city%20lights%2C%20crime%20thriller%20series%20poster%2C%20cool%20grey%20with%20warm%20amber%20accent%2C%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=tv-poster-08&orientation=portrait",
    updatedAt: "2025-09-26",
    summary: "刑警小队与时间赛跑，在天亮之前解开一桩桩疑难案件。",
    synopsis: "刑侦支队成立了一支专门攻坚陈年积案的小队，队长沉稳果决，队员各有所长。每集聚焦一个案件，同时用一条贯穿全剧的暗线串联起主角们的过去。剧集节奏紧凑，推理严谨，兼顾案件精彩与人性刻画。",
  },
  {
    id: "jin-xiu-chang-ge",
    title: "锦绣长歌",
    type: "tvseries",
    genres: ["历史", "古装", "剧情"],
    year: 2024,
    region: "中国大陆",
    rating: 8.3,
    hot: 99800,
    duration: "全52集",
    director: "慕容清",
    cast: ["云初", "谢景行", "白露"],
    poster: "https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20palace%20hall%20with%20silk%20banners%20and%20a%20regal%20figure%20in%20flowing%20robes%2C%20historical%20costume%20drama%20poster%2C%20rich%20deep%20red%20and%20gold%20tones%2C%20painterly%20style%2C%20no%20text&width=600&height=900&seq=tv-poster-09&orientation=portrait",
    updatedAt: "2025-07-18",
    summary: "深宫与朝堂之间，一位女子的锦绣一生与家国沉浮。",
    synopsis: "以一位出身书香门第的女子为主线，讲述她在风云变幻的朝堂与深宫中，凭借智慧与坚韧守护家人与信念的一生。剧集服化道考究，叙事张弛有度，展现了壮阔而细腻的历史画卷。",
  },
  {
    id: "du-shi-wei-guang",
    title: "都市微光",
    type: "tvseries",
    genres: ["都市", "爱情", "剧情"],
    year: 2025,
    region: "中国大陆",
    rating: 8.0,
    hot: 88900,
    duration: "全30集",
    director: "温以宁",
    cast: ["夏栀", "顾韩", "许清晏"],
    poster: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20blue%20hour%20with%20glowing%20office%20windows%20and%20a%20young%20professional%20walking%20home%2C%20urban%20romance%20series%20poster%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=tv-poster-10&orientation=portrait",
    updatedAt: "2025-09-15",
    summary: "在快节奏的都市里，几个年轻人彼此照亮，寻找属于自己的微光。",
    synopsis: "三个合租的年轻人在大城市打拼，工作、感情与理想交织成一幅当代都市生活的群像。剧集不刻意制造戏剧冲突，而是用真实的生活细节与温暖的基调，讲述普通人如何在平凡日子里相互支撑。",
  },
  {
    id: "shen-lan-dang-an",
    title: "深蓝档案",
    type: "tvseries",
    genres: ["科幻", "悬疑", "剧情"],
    year: 2025,
    region: "中国大陆",
    rating: 8.6,
    hot: 118500,
    duration: "全24集",
    director: "顾云帆",
    cast: ["蓝意", "江砚", "方锐"],
    poster: "https://readdy.ai/api/search-image?query=Mysterious%20deep%20blue%20underground%20laboratory%20with%20glowing%20data%20screens%20and%20a%20lone%20researcher%2C%20sci-fi%20mystery%20series%20poster%2C%20deep%20teal%20shadow%20with%20warm%20orange%20glow%2C%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=tv-poster-11&orientation=portrait",
    updatedAt: "2025-10-08",
    summary: "一份尘封的深蓝档案，牵出一段被隐藏的高科技往事。",
    synopsis: "一位研究员在整理旧资料时发现一份编号“深蓝”的绝密档案，随之而来的是一连串无法用常理解释的事件。剧集将悬疑推理与科幻设定结合，在抽丝剥茧中探讨记忆、身份与科技伦理的边界。",
  },
  {
    id: "gui-tu-lie-che",
    title: "归途列车",
    type: "movie",
    genres: ["剧情", "公路", "家庭"],
    year: 2025,
    region: "中国大陆",
    rating: 8.1,
    hot: 76300,
    duration: "122分钟",
    director: "韩振国",
    cast: ["秦卫东", "苏晚", "何永年"],
    poster: "https://readdy.ai/api/search-image?query=Old%20green%20train%20traveling%20through%20snowy%20countryside%20at%20dusk%20with%20warm%20lit%20windows%2C%20road%20drama%20movie%20poster%2C%20muted%20warm%20earth%20tones%20with%20deep%20red%20accent%2C%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=mv-poster-12&orientation=portrait",
    updatedAt: "2025-10-10",
    summary: "一趟跨越千里的归途列车，载着一车素不相识的人与各自的心事。",
    synopsis: "春运时节，一列慢车从南到北缓缓行驶。车厢里聚集了形形色色的旅客：归乡的工人、出走的少年、重逢的旧友。影片以密闭空间中的群像叙事，串联起一段段关于家、离别与期盼的故事，克制而动人。",
  },
];